import { ApiWrapper, RestService } from '@wemogy/reactbase';

export default class BackupService extends RestService<any>{
  public constructor(apiWrapper: ApiWrapper){
    super(apiWrapper, 'backup');
  }
}
